import { render } from "./Equipments.vue?vue&type=template&id=13299784"
import script from "./Equipments.vue?vue&type=script&lang=js"
export * from "./Equipments.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__